
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { ToastContainer, Toast } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
    FaMapMarkerAlt,
    FaRulerCombined,
    FaExpand,
    FaBorderAll,
    FaCubes,
    FaSave,
    FaArrowLeft,
} from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import API from "./Fetchs";

const EditarTabla = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const toastRef = useRef(null);
    const [formData, setFormData] = useState({
        direccion: "",
        lugar: "",
        cantidad_hectareas: "",
        superficie_terreno: "",
        medida_frente: "",
        medida_fondo: "",
        superficie_cubierta: "",
        superficie_semicubierta: "",
        descripcion: "",
        tipo_inmueble: "",
        ubicacion: "",
    });
    const [mensaje, setMensaje] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${API.read}?id=${id}`
                );
                const data = response.data;
                setFormData({
                    direccion: data.direccion,
                    lugar: data.lugar,
                    cantidad_hectareas: data.cantidad_hectareas,
                    superficie_terreno: data.superficie_terreno,
                    medida_frente: data.medida_frente,
                    medida_fondo: data.medida_fondo || "",
                    superficie_cubierta: data.superficie_cubierta || "",
                    superficie_semicubierta: data.superficie_semicubierta || "",
                    descripcion: data.descripcion,
                    tipo_inmueble: data.tipo_inmueble,
                    ubicacion: data.ubicacion,
                });
                setLoading(false);
            } catch (error) {
                setMensaje("❌ Error al cargar los datos");
                console.error("Error:", error);
                setLoading(false);
            }
        };
        fetchData();
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje("ℹ️ Guardando...");
        try {
            const data = new FormData();
            Object.keys(formData).forEach((key) => data.append(key, formData[key]));
            const response = await fetch(
                `${API.update}?id=${id}`,
                {
                    method: "POST",
                    body: data,
                }
            );
            const resultText = await response.text();
            let result;
            try {
                result = JSON.parse(resultText);
            } catch (e) {
                setMensaje("❌ Error inesperado en el servidor");
                return;
            }
            if (result.success) {
                setMensaje("✅ Datos actualizados correctamente");
                setTimeout(() => navigate("/tabla"), 500);
            } else {
                setMensaje("❌ Error al actualizar los datos");
            }
        } catch (error) {
            console.error("Error al guardar:", error);
            setMensaje("❌ Error en la conexión");
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    if (loading) return <p className="text-center mt-5">Cargando datos...</p>;

    return (
        <div
            className="container contenedor-depto"
            style={{
                marginTop: "7em",
                fontFamily: "'Poppins', sans-serif", // Fuente moderna
            }}
        >
            {/* Botón de Retroceso */}
            <button
                className="btn btn-success mb-4 d-flex align-items-center"
                onClick={handleCancel}

            >
                <FaArrowLeft className="me-2" /> Volver
            </button>

            {/* Encabezado */}
            <h2
                className="text-center mb-4"
                style={{
                    color: "#6EB41E",
                    fontWeight: "bold",
                    fontSize: "2rem",
                    textTransform: "uppercase",
                }}
            >
                Editar Propiedad
            </h2>

            {/* Notificaciones */}
            <div ref={toastRef}>
                <ToastContainer position="top-center" className="mt-3">
                    <Toast
                        show={!!mensaje}
                        onClose={() => setMensaje("")}
                        delay={3000}
                        autohide
                        bg={mensaje.includes("✅") ? "success" : "danger"}
                    >
                        <Toast.Header>
                            <strong className="me-auto">Notificación</strong>
                        </Toast.Header>
                        <Toast.Body className="text-white d-flex align-items-center">
                            <span className="me-2">{mensaje.charAt(0)}</span>
                            <span>{mensaje.slice(2)}</span>
                        </Toast.Body>
                    </Toast>
                </ToastContainer>
            </div>

            {/* Formulario */}
            <form onSubmit={handleSubmit} className="mt-4">
                <div className="row g-4">
                    {/* Dirección y Lugar */}
                    <div className="col-md-6">
                        <label
                            className="form-label d-flex align-items-center"
                            style={{ fontWeight: "bold", fontSize: "1rem" }}
                        >
                            <FaMapMarkerAlt className="me-2 fs-4" />
                            Dirección <span className="text-danger ms-1">*</span>
                        </label>
                        <input
                            type="text"
                            name="direccion"
                            className="form-control shadow-sm"
                            value={formData.direccion}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="col-md-6">
                        <label
                            className="form-label d-flex align-items-center"
                            style={{ fontWeight: "bold", fontSize: "1rem" }}
                        >
                            <FaMapMarkerAlt className="me-2 fs-4" />
                            Lugar
                        </label>
                        <input
                            type="text"
                            name="lugar"
                            className="form-control shadow-sm"
                            value={formData.lugar}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Tipo de Inmueble */}
                    <div className="col-md-6">
                        <label
                            className="form-label"
                            style={{ fontWeight: "bold", fontSize: "1rem" }}
                        >
                            Tipo de Inmueble <span className="text-danger ms-1">*</span>
                        </label>
                        <select
                            name="tipo_inmueble"
                            className="form-select shadow-sm"
                            value={formData.tipo_inmueble}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccionar tipo</option>
                            <option value="campos">Campo</option>
                            <option value="casa">Casa</option>
                            <option value="departamentos">Departamento</option>
                            <option value="forestaciones">Forestaciones</option>
                            <option value="galpones">Galpón</option>
                            <option value="oficinas">Locales y Oficinas</option>
                            <option value="quintas">Quinta</option>
                            <option value="terreno">Terreno</option>
                            <option value="otras">Otras Prop.</option>
                        </select>
                    </div>

                    {/* Medidas */}
                    <div className="col-md-12">
                        <div className="card p-4 shadow">
                            <h5
                                className="mb-3"
                                style={{ color: "#6EB41E", fontWeight: "bold" }}
                            >
                                Medidas
                            </h5>
                            <div className="row g-3">
                                <div className="col-md-4">
                                    <label
                                        className="form-label d-flex align-items-center"
                                        style={{ fontWeight: "bold", fontSize: "1rem" }}
                                    >
                                        <FaRulerCombined className="me-2 fs-4" />
                                        Cantidad de Hectáreas
                                    </label>
                                    <input
                                        type="number"
                                        name="cantidad_hectareas"
                                        className="form-control shadow-sm"
                                        value={formData.cantidad_hectareas}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label
                                        className="form-label d-flex align-items-center"
                                        style={{ fontWeight: "bold", fontSize: "1rem" }}
                                    >
                                        <FaExpand className="me-2 fs-4" />
                                        Superficie del Terreno (m²)
                                    </label>
                                    <input
                                        type="number"
                                        name="superficie_terreno"
                                        className="form-control shadow-sm"
                                        value={formData.superficie_terreno}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label
                                        className="form-label d-flex align-items-center"
                                        style={{ fontWeight: "bold", fontSize: "1rem" }}
                                    >
                                        <FaBorderAll className="me-2 fs-4" />
                                        Medida del Frente
                                    </label>
                                    <input
                                        type="number"
                                        name="medida_frente"
                                        className="form-control shadow-sm"
                                        value={formData.medida_frente}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label
                                        className="form-label d-flex align-items-center"
                                        style={{ fontWeight: "bold", fontSize: "1rem" }}
                                    >
                                        <FaBorderAll className="me-2 fs-4" />
                                        Medida de Fondo
                                    </label>
                                    <input
                                        type="number"
                                        name="medida_fondo"
                                        className="form-control shadow-sm"
                                        value={formData.medida_fondo}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label
                                        className="form-label d-flex align-items-center"
                                        style={{ fontWeight: "bold", fontSize: "1rem" }}
                                    >
                                        <FaCubes className="me-2 fs-4" />
                                        Superficie Cubierta (m²)
                                    </label>
                                    <input
                                        type="number"
                                        name="superficie_cubierta"
                                        className="form-control shadow-sm"
                                        value={formData.superficie_cubierta}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label
                                        className="form-label d-flex align-items-center"
                                        style={{ fontWeight: "bold", fontSize: "1rem" }}
                                    >
                                        <FaCubes className="me-2 fs-4" />
                                        Superficie Semicubierta (m²)
                                    </label>
                                    <input
                                        type="number"
                                        name="superficie_semicubierta"
                                        className="form-control shadow-sm"
                                        value={formData.superficie_semicubierta}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Descripción */}
                    <div className="col-md-12">
                        <label
                            className="form-label"
                            style={{ fontWeight: "bold", fontSize: "1rem" }}
                        >
                            Descripción
                        </label>
                        <textarea
                            className="form-control shadow-sm"
                            name="descripcion"
                            value={formData.descripcion}
                            onChange={handleChange}
                            rows="4"
                        />
                    </div>

                    {/* Ubicación */}
                    <div className="col-md-12">
                        <label
                            className="form-label"
                            style={{ fontWeight: "bold", fontSize: "1rem" }}
                        >
                            Ubicación en Google Maps
                        </label>
                        <input
                            type="text"
                            name="ubicacion"
                            className="form-control shadow-sm"
                            value={formData.ubicacion}
                            onChange={handleChange}
                        />
                    </div>

                    {/* Botones */}
                    <div className="d-flex gap-3 mt-5 mb-5">
                        <button
                            type="submit"
                            className="btn btn-success btn-lg rounded-pill shadow"
                            style={{
                                backgroundColor: "#6EB41E",
                                borderColor: "#6EB41E",
                                transition: "transform 0.3s ease",
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                        >
                            <FaSave className="me-2" /> Guardar Cambios
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger btn-lg rounded-pill shadow"
                            onClick={handleCancel}
                            style={{
                                transition: "transform 0.3s ease",
                            }}
                            onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                            onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                        >
                            Cancelar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EditarTabla;